export default __webpack_public_path__ + "static/media/radovan_xl.6a631f56.jpg";